/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Drawer } from "antd";
import ReservationForm from "./reservation/ReservationForm";

const BookingDrawer = ({ open, onClose, room, date = null, booking_type }) => {
  return (
    <Drawer
      title="New Reservation"
      width={1500}
      open={open}
      onClose={() => {
        onClose();
      }}
      destroyOnClose={true}
      closable={true}
      styles={{
        body: {
          padding: 0,
        },
      }}
    >
      <ReservationForm room={room} date={date} booking_type={booking_type} />
    </Drawer>
  );
};

export default BookingDrawer;
